/**
 * Short text flashed at the center of the view (2026-10-26, first used for
 * the stats panel's 3D Mode switch: "3D Mode" / "2D Mode").
 *
 * show() puts the text up at full opacity for HOLD_MS, then it fades out
 * over the CSS fade (ftgs-center-notice.scss) and is hidden. A new show()
 * while a text is up - holding or already fading - replaces it at once:
 * the timers restart and the fade class goes, which snaps the opacity back
 * to 1 (the transition only runs while fading), so quick switches never
 * queue up or blend into each other.
 *
 * In stereo split view main.ts mirrors this element like the other
 * overlays (ftgs-stereo-mirror.ts), so it sits at the center of each half -
 * the center each eye sees - not on the seam between them. The copy
 * follows the class changes, so its fade runs in step.
 */

/** how long the text stays fully visible before the fade starts */
const HOLD_MS = 1000;
/** must match the opacity transition in ftgs-center-notice.scss */
const FADE_MS = 200;

class FtgsCenterNotice {
    readonly dom: HTMLDivElement;
    private holdTimer: number | null = null;
    private hideTimer: number | null = null;

    constructor() {
        this.dom = document.createElement('div');
        this.dom.className = 'ftgs-center-notice';
        this.dom.setAttribute('aria-live', 'polite');
    }

    show(text: string) {
        this.clearTimers();
        this.dom.textContent = text;
        this.dom.classList.remove('ftgs-center-notice-fade');
        this.dom.classList.add('ftgs-center-notice-visible');
        this.holdTimer = window.setTimeout(() => {
            this.holdTimer = null;
            this.dom.classList.add('ftgs-center-notice-fade');
            this.hideTimer = window.setTimeout(() => {
                this.hideTimer = null;
                this.dom.classList.remove('ftgs-center-notice-visible', 'ftgs-center-notice-fade');
            }, FADE_MS);
        }, HOLD_MS);
    }

    private clearTimers() {
        if (this.holdTimer !== null) {
            window.clearTimeout(this.holdTimer);
            this.holdTimer = null;
        }
        if (this.hideTimer !== null) {
            window.clearTimeout(this.hideTimer);
            this.hideTimer = null;
        }
    }
}

export { FtgsCenterNotice };
